// components/ui/Modal.jsx
import ReactDOM from "react-dom";

export default function Modal({ open, onClose, children }) {
  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      aria-modal="true"
      role="dialog"
    >
      {/* backdrop */}
      <div
        className="absolute inset-0 bg-black/30 backdrop-blur-sm"
        onClick={onClose}
      />
      {/* card */}
      <div className="custom-container p-4 rounded shadow flex flex-col gap-4 max-w-sm w-full relative">
        {children}
      </div>
    </div>,
    document.body
  );
}
